import { createReducer, on } from '@ngrx/store';
import { MdmAppleDevicesApiActions, MdmAppleProfileEffectsActions } from './apple-profile.actions';
import { initialState, adapter } from './apple-profile.state';

export const appleProfileReducer = createReducer(
  initialState,
  on(MdmAppleDevicesApiActions.profilesLoaded, (state, { profiles }) => adapter.upsertMany(profiles, state)),
  on(MdmAppleProfileEffectsActions.profileAdded, (state, { profile }) => adapter.upsertOne(profile, state)),
  on(MdmAppleProfileEffectsActions.profileRemoved, (state, { udid, profileIdentifier }) =>
    adapter.removeOne(`${udid}-${profileIdentifier}`, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectProfileIds = selectIds;

export const selectAppleProfileEntities = selectEntities;

export const selectAllProfiles = selectAll;
